import Content from './content.component'

export default Content;